import { useEffect, useState } from "react";
import reqProduto from "../../../services/reqMultiTenant/reqProduto";
import CardItem from "./cardItens";
import dataInfoProduct from "../db";

const CardProduct = () => {
	const [dataProducts, setDataProducts] = useState([]);
	const dataInfo = dataInfoProduct;

	const fetch = async () => {
		const result = await reqProduto.listProductsHomeSZ();
		setDataProducts(result.data);
	};

	useEffect(() => {
		fetch();

		// Ativar scroll suave
		document.documentElement.style.scrollBehavior = "smooth";
		return () => {
			document.documentElement.style.scrollBehavior = "auto";
		};
	}, []);

	// Agrupar produtos por id_tipoproduto
	const groupedProducts = dataProducts.reduce((groups, product) => {
		const tipo = product.id_tipoproduto;
		if (!groups[tipo]) {
			groups[tipo] = [];
		}
		groups[tipo].push(product);
		return groups;
	}, {});

	const categories = Object.entries(groupedProducts).map(([tipo, products]) => ({
		tipo,
		categoria: products[0]?.categoria || `Tipo ${tipo}`,
	}));

	return (
		<div className="mx-auto max-w-5xl px-4">
			{/* Menu de navegação fixo */}
			{/* Menu de navegação por categorias (Tabs Modernas) */}
			<div className="sticky top-20 z-30 bg-white/80 backdrop-blur-md shadow-sm border border-gray-100 rounded-2xl mb-12 p-2 flex gap-2 justify-start md:justify-center overflow-x-auto whitespace-nowrap hide-scrollbar">
				{categories.map(({ tipo, categoria }) => (
					<a
						key={tipo}
						href={`#categoria-${tipo}`}
						className="px-6 py-2.5 text-sm font-semibold text-gray-600 hover:text-blue-700 hover:bg-blue-50 bg-transparent rounded-xl transition-all duration-200"
					>
						{categoria}
					</a>
				))}
			</div>

			{/* Listagem de produtos */}
			{Object.entries(groupedProducts).map(([tipo, products]) => {
				const categoria = products[0]?.categoria || `Tipo ${tipo}`;

				return (
					<div key={tipo} id={`categoria-${tipo}`} className="mb-16 scroll-mt-36">
						{/* Cabeçalho da categoria moderno */}
						<div className="flex items-center gap-3 mb-8 pb-3 border-b border-gray-200">
							<div className="h-8 w-1.5 bg-blue-600 rounded-full"></div>
							<h2 className="text-2xl font-extrabold text-gray-900 tracking-tight">{categoria}</h2>
						</div>

						{/* Grid de produtos */}
						<div className="grid grid-cols-12 gap-4">
							{products.map((product) => {
								const productInfo = dataInfo.find((info) => info.id_produto === product.id_produto);

								return (
									<div
										key={product.id_produto}
										className="col-span-12 lg:col-span-4 sm:col-span-6 transition-transform hover:-translate-y-2 hover:shadow-xl rounded-2xl"
									>
										<CardItem product={product} productInfo={productInfo} />
									</div>
								);
							})}
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default CardProduct;
